import React from "react";
import { SearchIcon } from "../icon/IconTheme";

const SearchForm = () => {
	return (
		<form className="search-form">
			<div className="__search-form">
				<input
					type="text"
					className="form-control form--control"
					placeholder="Search by ID"
				/>
				<div className="left-icon">
					<SearchIcon />
				</div>
			</div>
		</form>
	);
};

export default SearchForm;
